const linguagem = 'br';

const opcoes = {
  numeric: false,
  sensitivity: 'base'
};

const ehNumero = (str) => {
  return !isNaN(parseFloat(str))
}

const getCallbackOrdenacao = (value, order) => {
  const ordemInicial = (a) => {
    const item_array_inicial = array_inicial[a.index_of] || {};
    return `${a[value]}`.localeCompare(`${item_array_inicial[value]}`, linguagem, opcoes);
  };

  const ordemCrescente = (a, b) => {
    return `${a[value]}`.localeCompare(`${b[value]}`, linguagem, opcoes);
  };

  const ordemDecrescente = (a, b) => {
    return `${b[value]}`.localeCompare(`${a[value]}`, linguagem, opcoes);
  };

  if (order === 'up') {
    return ordemCrescente;
  }

  if (order === 'down') {
    return ordemDecrescente;
  }

  return ordemInicial;
}

let array_inicial = null;

export default (itens, value, order) => {
  if (!array_inicial && itens.length > 0) {
    array_inicial = itens.map(item => Object.assign({}, item));
  }

  opcoes.numeric = itens.every(item => ehNumero(item[value]));

  const funcaoOrdenacao = getCallbackOrdenacao(value, order);
  itens.sort(funcaoOrdenacao)
}
